import { combineReducers, configureStore } from '@reduxjs/toolkit';
import type { PreloadedState } from '@reduxjs/toolkit';
import { baseApi, basePersistentApi } from './baseApi';
import stripePaymentReducer from '@store/stripePaymentSlice';
import tableReducer from '@features/Table/store/tableSlice';

// Create the root reducer separately so we can extract the RootState type
const rootReducer = combineReducers({
  [baseApi.reducerPath]: baseApi.reducer,
  [basePersistentApi.reducerPath]: basePersistentApi.reducer,
  stripePayment: stripePaymentReducer,
  table: tableReducer,
});

export const setupStore = (preloadedState?: PreloadedState<RootState>) => {
  return configureStore({
    reducer: rootReducer,
    preloadedState,
    middleware: (getDefaultMiddleware: any) =>
      getDefaultMiddleware({
        serializableCheck: false,
      })
        .concat(baseApi.middleware)
        .concat(basePersistentApi.middleware),
  });
};

export type RootState = ReturnType<typeof rootReducer>;
export type AppStore = ReturnType<typeof setupStore>;
export type AppDispatch = AppStore['dispatch'];
